import * as React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRouter from "./AppRouter";
import { SnackbarProvider } from "notistack";
import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { UserProvider } from "../context/UserContext";
import { getAppEnvironmentName } from "../utilities/helpers/helperfunctions";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "../../theme";
import GlobalStyles from "../../theme/globalStyles";
import NewRelicRouteTracker from "../components/NewRelicRouteTracker";

const App = () => {
    React.useEffect(() => {
        const envName = getAppEnvironmentName();
        document.title = `Canvas${envName ? " | " + envName : ""}`;
    }, []);
    return (
        <Authenticator hideSignUp>
            {({ signOut, user }) => (
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <GlobalStyles />
                    <UserProvider>
                        <SnackbarProvider
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "center",
                            }}
                        >
                            <Router>
                                <NewRelicRouteTracker />
                                <AppRouter />
                            </Router>
                        </SnackbarProvider>
                    </UserProvider>
                </ThemeProvider>
            )}
        </Authenticator>
    );
};

export default App;
